<template>
  <div class="dash_right">
    <rightTop :activeRate="activeRate"></rightTop>
    <template v-if="activeRate==='seller'">
      <cardList :activeRate="activeRate"></cardList>
      <chartView ref="chartBox1" :activeRate="activeRate"></chartView>
      <chartBox></chartBox>
      <sortTop :activeRate="activeRate" :type="'debtors'"></sortTop>
    </template>
    <template v-if="activeRate==='buyer'">
      <buy-cardList v-if="activeRate==='buyer'" :activeRate="activeRate"></buy-cardList>
      <RoiColumnar :activeRate="activeRate"></RoiColumnar>
<!--      <ExpectedColumnar ref="chartBox" :activeRate="activeRate"></ExpectedColumnar>-->
      <PaymentChart></PaymentChart>
      <sellerTop></sellerTop>
      <debtorTop></debtorTop>
    </template>
  </div>
</template>
<script>
import rightTop from "./rightTop";
import cardList from "./cardList";
import chartView from "./chartView";
import sortTop from "./sortTop";
import chartBox from "./chartBox";
import ExpectedColumnar from "./buyer/ExpectedColumnar";
import buyCardList from "./buyCardList";
import RoiColumnar from "./buyer/RoiColumnar";
import debtorTop from "./buyer/debtorTop";
import sellerTop from "./buyer/sellerTop";
import PaymentChart from "./buyer/PaymentChart";

export default {
  props: {
    activeRate: [Number, String]
  },
  mounted() {},
  components: {
    PaymentChart,
    rightTop,
    cardList,
    chartView,
    sortTop,
    chartBox,
    ExpectedColumnar,
    buyCardList,
    RoiColumnar,
    debtorTop,
    sellerTop
  },
  methods: {}
};
</script>